import React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { selectAssemblyDataForPrices } from 'shared/product_tabs/tab_assembly/slice/selectors';
import { priceSelected } from 'shared/product_tabs/tab_assembly/slice/assemblySlice';
import { ERROR, QUOTING } from 'shared/data/quoteSteps';

import AutomaticQuoteError from 'shared/components/AutomaticQuoteError';
import PriceUS from 'shared/product_tabs/tab_assembly/components/PriceUS';
import PriceMX from 'shared/product_tabs/tab_assembly/components/PriceMx';
import QuoteLoading from 'shared/components/price/QuoteLoading';

const Prices = () => {
  const dispatch = useDispatch();
  const {
    quote,
    parametersChanged,
    parameters,
    quoteStep,
    assemblyVariants,
  } = useSelector(selectAssemblyDataForPrices);

  const onPriceSelect = (data) => {
    dispatch(priceSelected({ ...data, currentVariant: assemblyVariants[data.supplier] }));
  };

  if (quoteStep === ERROR) {
    return <AutomaticQuoteError />;
  }

  if (quoteStep === QUOTING) {
    return <QuoteLoading />;
  }

  const props = {
    quote,
    quoteStep,
    parameters,
    parametersChanged,
    onPriceSelect,
  };

  return (
    <div className="container-fluid quote-result">
      <PriceUS {...props} />
      <PriceMX {...props} />
    </div>
  );
};

export default Prices;
